import { gql } from '@apollo/client';

export const ActivityDescriptionFragments = gql`
  fragment ActivityDescription on VOLUNTEER_ActivityType {
    name
    description
  }
`;
